import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { useGamificationContext } from '@/shared/Gamification/GamificationContext/GamificationContext';
import startStarsAnimation from './starsAnimation';
import {
  ANCHOR,
  getElementCoordinates,
} from '@/modules/dom/getElementCoordinates';

export default function useAnimatedStars({
  starsRef,
  originSelector,
  originAnchor,
  iframeStarsOrigin,
}) {
  const { state: gamificationState, actions: gamificationActions } =
    useGamificationContext();
  const { state, actions } = useCustomHook({
    defaultState: { animating: false },
    actions: {
      onAnimationEnded: () => {
        actions.setState({ animating: false });
        gamificationActions.onStarsAnimationEnd();
      },
    },
  });

  useEffect(() => {
    if (gamificationState.gainedStars) {
      try {
        const topTargetEl = document.querySelector('.topbar-scoreboard');
        const fullScreenTargetEl = document.querySelector(
          '.score-board:not(.topbar-scoreboard)'
        );
        const target = getElementCoordinates(
          fullScreenTargetEl || topTargetEl,
          ANCHOR.CENTER
        );
        let origin;
        if (iframeStarsOrigin) {
          const iframeOrigin = getElementCoordinates(
            originSelector,
            originAnchor
          );
          origin = {
            x: iframeOrigin.x + iframeStarsOrigin.x,
            y: iframeOrigin.y + iframeStarsOrigin.y,
          };
        } else {
          origin = getElementCoordinates(originSelector, originAnchor);
        }
        startStarsAnimation({
          stars: starsRef.current.slice(0, gamificationState.gainedStars),
          origin,
          target,
          onEnd: actions.onAnimationEnded,
        });
      } catch (e) {
        console.error(e);
        actions.onAnimationEnded();
      }
    }
  }, [gamificationState.gainedStars]);

  return { state, actions };
}
